import { PureComponent, Fragment } from 'react';
import Form from 'react-bootstrap/lib/Form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CmsBlock from 'components/CmsBlock';
import LazyImage from 'components/LazyImage';
import { reduxForm } from 'redux-form';
import { GroupField } from 'components/forms/GroupField';
import BrandButton from 'components/BrandButton';

import { EMAIL_SUBSCRIPTION_FORM } from './constants';
import validate from './validate';

import CheckIcon from './icons/CheckIcon.com.svg';
import carImage from './images/car.png';

import mapStateToProps from './mapStateToProps';
import * as actions from './actions';
import cn from './styles.local.less';

class EmailSubscriptionWidget extends PureComponent {
  static propTypes = {
    cmsDescription: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    submitEmailSubscription: PropTypes.func.isRequired,
    isFormSubmittedSuccessfully: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    cmsDescription: '',
  };

  handleSubmit = () => {
    const { submitEmailSubscription } = this.props;

    submitEmailSubscription();
  };

  render() {
    const { cmsDescription, handleSubmit, isFormSubmittedSuccessfully } =
      this.props;

    return (
      <div className={cn.root}>
        <div className={cn.container}>
          <div className={cn.leftSide}>
            <div className={cn.title}>
              {__('emailSubscriptionWidget.title')}
            </div>
            <div className={cn.secondaryText}>
              {__('emailSubscriptionWidget.secondaryText')}
            </div>
            <Form noValidate onSubmit={handleSubmit(this.handleSubmit)}>
              <div className={cn.form}>
                {isFormSubmittedSuccessfully ? (
                  <div className={cn.submitSuccess}>
                    <div>
                      <CheckIcon className={cn.checkIcon} />
                    </div>
                    <div className="hidden-xs">
                      {__('emailSubscriptionWidget.successMessageDesktop')}
                    </div>
                    <div className="visible-xs">
                      {__('emailSubscriptionWidget.successMessageMobile')}
                    </div>
                  </div>
                ) : (
                  <Fragment>
                    <GroupField
                      name="email"
                      type="email"
                      placeholder={__(
                        'emailSubscriptionWidget.form.email.placeholder',
                      )}
                      className={cn.email}
                    />
                    <BrandButton
                      className={cn.submitBtn}
                      block
                      type="submit"
                      bsSize="small"
                    >
                      {__('emailSubscriptionWidget.form.button.submit')}
                    </BrandButton>
                  </Fragment>
                )}
              </div>
            </Form>
          </div>
          <div className="hidden-xs">
            <LazyImage alt="Car Image" src={carImage} />
          </div>
        </div>
        <CmsBlock className={cn.cmsContent} content={cmsDescription} />
      </div>
    );
  }
}

export default reduxForm({
  form: EMAIL_SUBSCRIPTION_FORM,
  touchOnBlur: false,
  validate,
})(connect(mapStateToProps, actions)(EmailSubscriptionWidget));
